import { __ } from 'localisation';

const getFormData = (nr, key) => {

  const data = [
    {
      id: 'autogiro_1',
      fields: [
        {
          type: 'subtitle',
          value: __('autogiro_subtitle'),
          description: __('autogiro_sub_description'),
        },
        {
          type: 'inputautofill',
          id: 'user_account',
          label: __('account_number'),
          // value: selectedUserAccount.name
          value: nr,
        },
      ]
    },
    {
      id: 'autogiro_2',
      fields: [
        {
          type: 'documents',
          class: 'no-border',
          title: __('terms'),
          id: 'contact.registration.general_terms_check_pdf',
          value: false,
          auth: false,
          documents: false,
          tags: 'autogiro,',
          path: 'terms'
        },
        {
          type: 'checkbox',
          id: key,
          label: __('autogiro_agree'),
          value: false
        },
      ]
    },
  ];
  return data;
};

export default getFormData;
